import { jsx as _jsx } from "react/jsx-runtime";
import { Component, Fragment } from "react";
import { AttributeErrorView } from "./AttributeErrorView";
export class AttributeErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.retryHandle = 0;
        this.state = {
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error,
        };
    }
    componentDidCatch(_error, _errorInfo) {
        const retry = this.props.retry;
        // do nothing
        if (retry != null && this.retryHandle) {
            this.retryHandle = window.setTimeout(() => {
                this.setState({ error: null });
            }, retry);
        }
    }
    componentWillUnmount() {
        if (this.retryHandle) {
            window.clearTimeout(this.retryHandle);
        }
    }
    render() {
        if (this.state.error) {
            if (this.props.hidden) {
                return _jsx(Fragment, {});
            }
            return (_jsx(AttributeErrorView, { error: this.state.error, attribute: this.props.attribute }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=AttributeErrorBoundary.js.map